<template>
  <footer class="footer">
    <div class="footer-container">
      <!-- Top Section -->
      <div class="footer-top">
        <div class="footer-left">
          <img :src="logoImage" alt="Nolido" class="footer-logo">
          <div class="footer-links">
            <router-link to="/legal" class="footer-link">Mentions légales</router-link>
            <router-link to="/terms" class="footer-link">Conditions générales d'utilisation</router-link>
            <router-link to="/privacy" class="footer-link">Politiques de confidentialités</router-link>
          </div>
        </div>
        <div class="footer-right">
          <div class="app-buttons">
            <a href="#" class="app-button app-store">
              <i class="fab fa-apple"></i>
              <div class="button-text">
                <span class="small-text">TÉLÉCHARGER SUR</span>
                <span class="large-text">App Store</span>
              </div>
            </a>
            <a href="#" class="app-button play-store">
              <i class="fab fa-google-play"></i>
              <div class="button-text">
                <span class="small-text">TÉLÉCHARGER SUR</span>
                <span class="large-text">Play Store</span>
              </div>
            </a>
          </div>
          <div class="social-icons">
            <a href="https://www.facebook.com/nolido" target="_blank" class="social-icon">
              <i class="fab fa-facebook-f"></i>
            </a>
            <a href="https://www.linkedin.com/company/nolido" target="_blank" class="social-icon">
              <i class="fab fa-linkedin-in"></i>
            </a>
            <a href="https://twitter.com/nolido" target="_blank" class="social-icon">
              <i class="fab fa-x-twitter"></i>
            </a>
            <a href="https://www.instagram.com/nolido" target="_blank" class="social-icon">
              <i class="fab fa-instagram"></i>
            </a>
          </div>
        </div>
      </div>

      <!-- Bottom Section -->
      <div class="footer-bottom">
        <p class="footer-description">
          La garantie d'un transfert aisé. Vos Informations, documents personnels sont bien traités et sécurisé de bout en bout.
        </p>
        <p class="footer-copyright">
          © {{ new Date().getFullYear() }} Nolido Cash
        </p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "app-footer",
  data() {
    return {
      logoImage: require('@/assets/img/logo.png')
    }
  }
};
</script>

<style scoped>
.footer {
  background: #F5F5F5;
  padding: 60px 0 40px;
}

.footer-container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 2rem;
}

/* Top Section */
.footer-top {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 3rem;
  gap: 3rem;
}

.footer-left {
  flex: 1;
}

.footer-logo {
  width: 140px;
  margin-bottom: 2rem;
  object-fit: contain;
}

.footer-links {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.footer-link {
  color: #666;
  text-decoration: none;
  font-size: 15px;
  font-weight: 400;
  transition: color 0.3s;
}

.footer-link:hover {
  color: #1A1A1A;
}

/* Right Section */
.footer-right {
  display: flex;
  flex-direction: column;
  gap: 2rem;
  align-items: flex-end;
}

.app-buttons {
  display: flex;
  gap: 1rem;
}

.app-button {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.75rem 1.5rem;
  background: white;
  border: 1px solid #E5E5E5;
  border-radius: 12px;
  text-decoration: none;
  transition: all 0.3s;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.app-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.app-button i {
  font-size: 28px;
}

.app-store i {
  color: #1A1A1A;
}

.play-store i {
  color: #5F6368;
}

.button-text {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.small-text {
  font-size: 10px;
  color: #666;
  font-weight: 500;
  letter-spacing: 0.5px;
  text-transform: uppercase;
}

.large-text {
  font-size: 16px;
  color: #1A1A1A;
  font-weight: 600;
  margin-top: -2px;
}

/* Social Icons */
.social-icons {
  display: flex;
  gap: 0.75rem;
}

.social-icon {
  width: 40px;
  height: 40px;
  background: #1A1A1A;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  text-decoration: none;
  transition: all 0.3s;
}

.social-icon:hover {
  background: #F5A847;
  transform: translateY(-3px);
}

.social-icon i {
  font-size: 16px;
}

/* Bottom Section */
.footer-bottom {
  border-top: 1px solid #E0E0E0;
  padding-top: 2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 2rem;
}

.footer-description {
  color: #666;
  font-size: 14px;
  margin: 0;
  max-width: 600px;
  line-height: 1.6;
}

.footer-copyright {
  color: #666;
  font-size: 14px;
  margin: 0;
  white-space: nowrap;
}

/* Responsive */
@media (max-width: 992px) {
  .footer-top {
    flex-direction: column;
    gap: 2rem;
  }

  .footer-right {
    align-items: flex-start;
    width: 100%;
  }

  .app-buttons {
    width: 100%;
    flex-wrap: wrap;
  }

  .app-button {
    flex: 1;
    min-width: 200px;
  }

  .footer-bottom {
    flex-direction: column;
    align-items: flex-start;
    gap: 1rem;
  }

  .footer-description {
    max-width: 100%;
  }
}

@media (max-width: 768px) {
  .footer {
    padding: 40px 0 30px;
  }

  .footer-container {
    padding: 0 1rem;
  }

  .footer-logo {
    width: 120px;
  }

  .app-buttons {
    flex-direction: column;
    width: 100%;
  }

  .app-button {
    width: 100%;
  }

  .social-icons {
    width: 100%;
    justify-content: center;
  }
}
</style>
